import { strings } from '../data/strings';

export default class ShortcutsComponent {
	constructor() {
		const swiper = new Swiper('.slider_shortcut_component', {
			slidesPerView: 3,
			spaceBetween: 90,

			navigation: {
				nextEl: '.slider-button-next',
				prevEl: '.slider-button-prev',
			},

			pagination: {
				el: '.slider-pagination',
				clickable: true,
			},

			breakpoints: {
				0: {
					slidesPerView: 1,
				},
				768: {
					slidesPerView: 1,
				},
				1024: {
					slidesPerView: 3,
				},
			},
		});

		const shortcutList = document.querySelector(".shortcuts_component .container .releases")
		const blocks = document.querySelectorAll(".releases .block-excerpt")
		const btn = document.querySelector(".shortcuts_component .container .btn-content .show-more-shortcuts")

		if (btn && (blocks.length <= 3)) {
			btn.classList.add('d-none')
		}

		if (blocks.length >= 3) {
			shortcutList.classList.add("collapse")
		}

		if (btn) {
			btn.addEventListener("click", function () {
				shortcutList.classList.toggle("collapse")
				btn.classList.toggle("active")

				if (btn.querySelector("span")) {
					if (btn.classList.contains("active")) {
						btn.querySelector("span").innerText = strings.see_less[ICL_LANGUAGE_CODE]
					} else {
						btn.querySelector("span").innerText = strings.see_more[ICL_LANGUAGE_CODE]
					}
				}
			})
		}
	}
}
new ShortcutsComponent();